import { ArrowDown } from "lucide-react";

export default function SceneNextLink({ href, label, className = "" }) {
  return (
    <a href={href} className={`scene-next-link focus-ring group absolute inline-flex min-h-11 items-center gap-3 rounded-full border border-white/15 bg-[#111214]/80 px-4 font-mono text-[11px] text-white/65 backdrop-blur-sm transition-colors hover:border-brand-500/40 hover:text-brand-300 ${className}`}>
      Next: {label}<ArrowDown aria-hidden="true" className="h-3.5 w-3.5 transition-transform group-hover:translate-y-0.5" />
    </a>
  );
}
